/**
 * The scrap feature (M8 plan MC-c7; RD8): registers `module.scrap` on the craft hook (`craft/hook.ts`), so
 * `UiActions.craft` scraps a locker module of the flown ship into materials in the hold (`career/fitting.ts
 * scrapModule`). No credits move and nothing reaches the worker (the handler never touches `ctx.market`). Only at the
 * docked station. The Outfitting row that calls it is a follow-up (`ui/models/outfitting.ts`, `scrapLines` gives its
 * preview); no station tab.
 */
import { FEATURE_ORDER, type GameFeature } from '../../app/feature'
import { scrapModule } from '../../career/fitting'
import { registerCraftHandler, type CraftCommandMap, type CraftHandler } from '../../craft/hook'
import type { CmdOutcome } from '../../ui/contracts'

/** After the career runtime (the registry is global, so the order only places it in the list). */
const ORDER = FEATURE_ORDER.career + 1

export const SCRAP_NOT_DOCKED = 'Dock at the station to scrap a module.'

/** The handler (exported for the tests; the feature registers it): only at the docked station. */
export const scrapHandler: CraftHandler<CraftCommandMap['module.scrap']> = (cmd, ctx): CmdOutcome => {
  const here = ctx.station
  if (here === null || here.id !== cmd.stationId) {
    return ctx.refuse({ code: 'serviceUnavailable', message: SCRAP_NOT_DOCKED, detail: { station: cmd.stationId } })
  }
  const r = scrapModule(ctx.career(), ctx.data, here, cmd.id)
  if (!r.ok) return ctx.refuse(r.error)
  ctx.commit(r.value, r.effects)
  return ctx.done()
}

let unregister: (() => void) | null = null

const feature: GameFeature = {
  name: 'scrap',
  order: ORDER,
  init(): void {
    unregister?.()
    unregister = registerCraftHandler('module.scrap', scrapHandler)
  },
  dispose(): void {
    unregister?.()
    unregister = null
  },
}

export default feature
